import { RETRY_OR_SUPPORT_MESSAGE, TERMINOLOGY } from '@shared/i18n';
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  Spinner,
} from '@fluentui/react-components';
import { Dispatch, SetStateAction } from 'react';
import { CustomMessageBar } from '@shared/components';

type TPollQueryLike = { isError: boolean; refetch: () => unknown };

type TPollingDialogProps = {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  // relaxed to a small surface we actually use, works for both hooks
  pollQuery: TPollQueryLike;
  isAnalysisFailed: boolean;
  label: string;
};

const PollingDialog = ({
  isOpen,
  setIsOpen,
  pollQuery,
  isAnalysisFailed,
  label = TERMINOLOGY.reference.lowerPlural,
}: TPollingDialogProps) => {
  const { isError, refetch } = pollQuery;
  const shouldShowError = isError || isAnalysisFailed;

  return (
    <Dialog
      modalType="alert"
      open={isOpen}
      onOpenChange={(_, data) => {
        if (!data.open) setIsOpen(false);
      }}
    >
      <DialogSurface>
        <DialogBody>
          {!shouldShowError ? (
            <DialogTitle className="flex items-center gap-2">
              <Spinner size="tiny" className="w-fit" appearance="primary" />
              {`Finalizing your ${label}`}
            </DialogTitle>
          ) : null}

          <DialogContent>
            {shouldShowError ? (
              <CustomMessageBar intent="error" title={`Error finalizing ${label}.`} body={RETRY_OR_SUPPORT_MESSAGE} />
            ) : (
              <>
                <p>{`We're inserting your ${label} into the selected documents.`}</p>
                <p>Keep this dialog open while we complete the process.</p>
              </>
            )}
          </DialogContent>

          {shouldShowError ? (
            <DialogActions>
              <Button appearance="secondary" onClick={() => setIsOpen(false)}>
                Close
              </Button>
              <Button appearance="primary" onClick={() => refetch()}>
                Retry
              </Button>
            </DialogActions>
          ) : null}
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export default PollingDialog;
